import React from 'react';
import './FAQ1.css';

const faqs = [
  {
    question: "What should I do if my transaction is pending but my account has been debited?",
    answer:
      "If a transaction is pending due to issues with the external Bill Service Provider and we haven't received confirmation, we will follow up and resolve the issue for you. You may log this issue via the Mini Statement, and we will ensure it is addressed."
  },
  {
    question: "What if my transaction failed and the amount was not credited back to my account?",
    answer:
      "For failed transactions, the amount is automatically credited back to the source account. If this does not occur, you can log the issue via the Mini Statement, and we will follow up to ensure resolution."
  },
  {
    question: "How can I secure my app?",
    answer:
      "To enhance security, change your password every six months and use complex passwords. Ensure privacy during login and usage of the app."
  },
  {
    question: "How do I contact customer support for assistance?",
    answer:
      "Log any grievances directly through the app for a swift resolution. Alternatively, you can call us at 7411068800 or email support@sabadotechnologies.com."
  },
  {
    question: "Should I share my OTP with anyone?",
    answer:
      "As a precaution against fraud, never share your OTP with anyone, including our staff. Always adhere to this best practice."
  }
];

const FAQ1 = () => (
  <section className="faq-section" id="faq">
    <div className="faq-container">
      <div className="faq-info">
        <h2 className="faq-title">Frequently Asked Questions</h2>
        <ul className="faq-list">
          {faqs.map((faq, idx) => (
            <li key={idx} className="faq-item">
              <h3>{idx + 1}. {faq.question}</h3>
              <p>{faq.answer}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default FAQ1;